import { createContext } from "react";

export const PageLeavePromptContext = createContext();
